import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ViewBlog() {
  const navigate = useNavigate();
  const { blogid } = useParams();
  const [formData, setFormData] = useState({});
  const [imagepath, setimagepath] = useState('');
  const [loading, setLoading] = useState(true);

  const callApiPostContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      // Corrected URL to match your routing
      const url = process.env.REACT_APP_API_URL + "posts/fetchblogbyid/" + blogid;
      const response = await axios.get(url, { headers });

      // Axios returns an array for this specific route based on your backend code
      const blogData = response.data[0];
      setFormData(blogData);

      if (blogData.featuredimage) {
        const fullimageurl = `${process.env.REACT_APP_API_URL}${blogData.featuredimage}`;
        setimagepath(fullimageurl);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error fetching blog details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    callApiPostContent();
  }, [blogid])

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="main-card">
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            View Blog Post
          </div>
          <div className="form-card-body">
            <Form>

              {/* Row 1: Sr No & Post Id */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="srno">
                  <Form.Label>Sr No:</Form.Label>
                  <Form.Control type="text" value={formData.srno || ''} readOnly />
                </Form.Group>
                <Form.Group as={Col} controlId="postid">
                  <Form.Label>Post Id:</Form.Label>
                  <Form.Control type="text" value={formData.postid || ''} readOnly />
                </Form.Group>
              </Row>

              {/* Row 2: Post Title & Category */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="posttitle">
                  <Form.Label>Post Title:</Form.Label>
                  <Form.Control type="text" value={formData.posttitle || ''} readOnly />
                </Form.Group>
                <Form.Group as={Col} controlId="category">
                  <Form.Label>Category:</Form.Label>
                  <Form.Control type="text" value={formData.category || ''} readOnly />
                </Form.Group>
              </Row>

              {/* Row 3: Post Heading & Author */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="postheading">
                  <Form.Label>Post Heading:</Form.Label>
                  <Form.Control type="text" value={formData.postheading || ''} readOnly />
                </Form.Group>
                <Form.Group as={Col} controlId="author">
                  <Form.Label>Author:</Form.Label>
                  <Form.Control type="text" value={formData.author || ''} readOnly />
                </Form.Group>
              </Row>

              {/* Post Content */}
              <Form.Group className="mb-3" controlId="content">
                <Form.Label>Post Content:</Form.Label>
                <div
                  className="p-3 border rounded bg-light"
                  dangerouslySetInnerHTML={{ __html: formData.content }}
                />
              </Form.Group>

              {/* Row 4: Featured Image & Icon */}
              <Row className="mb-3">
                <Col>
                  <Form.Label>Featured Image:</Form.Label>
                  {formData.featuredimage ? (
                    <div className="image-preview-container">
                      <img
                        src={imagepath}
                        alt="Featured"
                        loading="lazy"
                        className="image-preview"
                      />
                      <span className="image-preview-label">{formData.featuredimage}</span>
                    </div>
                  ) : (
                    <Form.Control type="text" value="No image uploaded" readOnly />
                  )}
                </Col>
                <Form.Group as={Col} controlId="featuredicon">
                  <Form.Label>Featured Icon:</Form.Label>
                  <Form.Control type="text" value={formData.featuredicon || ''} readOnly />
                </Form.Group>
              </Row>

              {/* Status */}
              <Form.Group className="mb-3">
                <Form.Label>Status:</Form.Label>
                <div>
                  <span className={formData.isactive === 1 ? 'badge-active' : 'badge-inactive'}>
                    {formData.isactive === 1 ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </Form.Group>

              {/* Form Actions */}
              <div className="form-actions">
                <Link to="/blogslist" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>

            </Form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default ViewBlog;